import type {FC} from 'react'
import * as icons from 'jbc-front/components/icons'

export interface ProcedureCategory {
  category: string
  icon: FC<icons.IconType>
  title: string
}

export const procedureCategories = [
  {
    category: 'enroll_and_resign',
    icon: icons.Procedure,
    title: '入退社・転勤',
  },
  {
    category: 'employee_info',
    icon: icons.SingleEmployee,
    title: '従業員情報の変更',
  },
  {
    category: 'childcare',
    icon: icons.BabyCar,
    title: '産休・育休',
  },
] as const satisfies readonly ProcedureCategory[]

export interface ProcedureType {
  procedureType: string
  title: string
  description: string
  category: (typeof procedureCategories)[number]['category']
  showInMypage: boolean // マイページの手続き一覧に表示するか
  supportsMypagePrefix: boolean // URLに `mypage/` を付与する必要があるか (マイページ用実装がある場合true)
  hasSubPage: boolean // 手続き開始前に種別選択等のサブページがあるか
}

export const procedureTypes = [
  {
    procedureType: 'enroll',
    title: '入社の手続き',
    description: '新しい従業員が入社するときの手続き',
    category: 'enroll_and_resign',
    showInMypage: false,
    supportsMypagePrefix: false,
    hasSubPage: true,
  },
  {
    procedureType: 'resign',
    title: '退社の手続き',
    description: '従業員が退社するときの手続き',
    category: 'enroll_and_resign',
    showInMypage: false,
    supportsMypagePrefix: false,
    hasSubPage: false,
  },
  {
    procedureType: 'change_office',
    title: '転勤の手続き',
    description: '転勤などで事業所の変更があるときの手続き',
    category: 'enroll_and_resign',
    showInMypage: false,
    supportsMypagePrefix: false,
    hasSubPage: false,
  },
  {
    procedureType: 'health_insurance_qualification_confirmation',
    title: '資格確認書交付の手続き',
    description: '資格確認書のみを個別に申請したいとき',
    category: 'enroll_and_resign',
    showInMypage: false,
    supportsMypagePrefix: false,
    hasSubPage: false,
  },
  {
    procedureType: 'change_name',
    title: '氏名の変更',
    description: '結婚などで氏名が変わるときの手続き',
    category: 'employee_info',
    showInMypage: true,
    supportsMypagePrefix: false,
    hasSubPage: false,
  },
  {
    procedureType: 'change_address',
    title: '住所の変更',
    description: '引越など住所が変わるときの手続き',
    category: 'employee_info',
    showInMypage: true,
    supportsMypagePrefix: false,
    hasSubPage: false,
  },
  {
    procedureType: 'change_dependents',
    title: '家族の変更',
    description: '家族情報の追加・削除があるときの手続き',
    category: 'employee_info',
    showInMypage: true,
    supportsMypagePrefix: true,
    hasSubPage: true,
  },
  {
    procedureType: 'maternity_leave',
    title: '産休の手続き',
    description: '産前産後休暇の手続き',
    category: 'childcare',
    showInMypage: true,
    supportsMypagePrefix: false,
    hasSubPage: true,
  },
  {
    procedureType: 'childcare_leave',
    title: '育休の手続き',
    description: '育児休業の手続き',
    category: 'childcare',
    showInMypage: true,
    supportsMypagePrefix: true,
    hasSubPage: true,
  },
  {
    procedureType: 'parental_leave',
    title: '出生時育休の手続き',
    description: '出生時育児休業の手続き',
    category: 'childcare',
    showInMypage: true,
    supportsMypagePrefix: true,
    hasSubPage: false,
  },
  {
    procedureType: 'parental_leave_support_allowance',
    title: '休業支援給付の手続き',
    description: '出生後休業支援給付を単独で行う手続き',
    category: 'childcare',
    showInMypage: true,
    supportsMypagePrefix: true,
    hasSubPage: false,
  },
] as const satisfies readonly ProcedureType[]
